import { render, staticRenderFns } from "./ListInmos.vue?vue&type=template&id=6a02e0a4&scoped=true"
import script from "./ListInmos.vue?vue&type=script&lang=js"
export * from "./ListInmos.vue?vue&type=script&lang=js"
import style0 from "./ListInmos.vue?vue&type=style&index=0&id=6a02e0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02e0a4",
  null
  
)

export default component.exports